import { put, call } from 'redux-saga/effects';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { BACKEND_URL } from '../../../configs';
import makeRequest from '../../../utils/makeRequest';
import processError from '../../../utils/processError';
import { OK } from '../../../configs/serverStatusCodes';
import {
  loadPermissionListFailed,
  loadPermissionListSuccessful,
  loadPermissionListBegin,
} from '../actions';

export default function* loadPermissionList(action) {
  try {
    const url = `${BACKEND_URL}/roles/permissions`;
    const pool = {};
    yield put(loadPermissionListBegin());
    const dataResponse = yield makeRequest(url, pool, action, 'POST', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(loadPermissionListSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadPermissionListFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadPermissionListFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
